'use strict';


import * as toastr from "toastr";

export var fnConnectToOutlay = function () {
    let elName = '#form_outlay_connect';

    if (!element_exists(elName)) return;

    let $el = $(elName);

    $el.off('submit').on('submit', function (e) {
        e.preventDefault();

        $.ajax({
            type: 'POST',
            data: $(this).serialize(),
            url: this.action,
            success: function (response) {
                if (response.url) {
                    window.location = response.url;
                }
            },
            error: fnToastrFormError
        });
    })
};

function element_exists(id) {
    return $(id).length !== 0;
}

function fnToastrFormError(data) {

    var errors = '';
    for (var datos in data.responseJSON.errors) {
        errors += data.responseJSON.errors[datos] + '<br>';
    }
    if (data.status == 403) {
        toastr.error(allLangFiles.forms.unauthorized);
    }
    if (errors != '') {
        toastr.error(errors);
    }
}